import { render, staticRenderFns } from "./InboundProcessingPlugin.vue?vue&type=template&id=361bcc95&"
import script from "./InboundProcessingPlugin.vue?vue&type=script&lang=ts&"
export * from "./InboundProcessingPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports